document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.swiss-legal');
  if (!root) return;

  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-legal-tab]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-legal-panel]'));

  function activate(key, smooth) {
    var found = false;
    var activeTab = null;

    tabs.forEach(function (tab) {
      var isMatch = tab.getAttribute('data-legal-tab') === key;
      tab.classList.toggle('is-active', isMatch);
      tab.setAttribute('aria-selected', isMatch ? 'true' : 'false');
      if (isMatch) {
        found = true;
        activeTab = tab;
      }
    });

    if (!found) return false;

    panels.forEach(function (panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-legal-panel') === key);
    });

    if (activeTab) {
      var tabsContainer = activeTab.closest('.swiss-legal__tabs');
      if (tabsContainer) {
        var containerRect = tabsContainer.getBoundingClientRect();
        var tabRect = activeTab.getBoundingClientRect();
        var offset = (tabRect.left + tabRect.width / 2) - (containerRect.left + containerRect.width / 2);
        tabsContainer.scrollBy({ left: offset, behavior: smooth ? 'smooth' : 'auto' });
      }
      window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
    }

    return true;
  }

  function activateFromHash(smooth) {
    var key = window.location.hash.replace('#', '');
    if (!key || !activate(key, smooth)) {
      if (tabs[0]) {
        activate(tabs[0].getAttribute('data-legal-tab'), smooth);
      }
    }
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var key = tab.getAttribute('data-legal-tab');
      if (activate(key, true)) {
        history.replaceState(null, '', '#' + key);
      }
    });
  });

  window.addEventListener('hashchange', function () {
    activateFromHash(true);
  });

  activateFromHash(false);
});